module.exports = __webpack_public_path__ + "img/unlocking.e013956a.svg";